import { Theme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { mobile, neutral, subText, white } from "theme/colors";

const settingsStyles = (theme: Theme) => {
  return {
    centerItem: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    labelBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      pb: 0.5,
    },
    inputLabel: {
      color: "primary.main",
      fontWeight: 600,
      fontSize: "14px",
      marginLeft: "5px !important",
    },
    chip: {
      maxHeight: "28px",
      ml: 1,
      mt: 1,
      borderRadius: "5px",
      "&.MuiChip-root ": {
        opacity: 1,
      },
      "&.MuiChip-label ": {
        color: subText,
      },
      "&.css-15ka1ix-MuiButtonBase-root-MuiChip-root .MuiChip-deleteIcon": {},
    },
    nameField: {
      textTransform: "capitalize",
      "& .MuiFormLabel-asterisk": {
        color: "red",
      },
    },
    select: {
      width: "100%",
      borderRadius: "8px !important",
      "&.MuiSelect-root": {
        borderRadius: "8px !important",
      },
      "& .MuiInputBase-input": {
        padding: "9px 13px",
      },
      "& .MuiSelect-select:focus-visible": {
        outline: "2px solid",
        outlineColor: "primary.main",
        outlineOffset: "-2px",
      },
      ".MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-clearIndicator": {
        color: "green",
      },
      marginTop: "8px !important",
    },
    errorStyling: {
      paddingLeft: "14px",
    },
    placeholderText: {
      color: subText,
    },
    selectedChip: {
      maxHeight: "28px",
      borderRadius: "10px",
      marginBottom: 1,
      marginRight: 1,
      "&.MuiChip-root ": {
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
        opacity: 1,
      },
      "&.MuiChip-label ": {
        color: mobile.base[900],
      },
      "&.css-15ka1ix-MuiButtonBase-root-MuiChip-root .MuiChip-deleteIcon": {
        color: mobile.base[900],
      },
    },
    card: {
      border: "1px solid #F0F0F0",
      borderRadius: "10px",
      boxShadow: 0,
    },
    optionStyle: {
      // ...regularFont,
    },
    checkbox: {
      "&.Mui-checked": {
        color: "#415A38",
      },
    },
    deleteButton: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: 4,
      padding: "5px 0px",
      cursor: "pointer",
    },
    viewModeBtn: {
      color: neutral[900],
      backgroundColor: "#e2e3e5",
      padding: "5px 15px",
      "&:hover": {
        backgroundColor: "#cfcfcf",
      },
    },
    viewModeBtnDark: {
      color: white,
      backgroundColor: "#444444",
      padding: "5px 15px",
      "&:hover": {
        backgroundColor: "#373737",
      },
    },
    dropDown: {
      width: "100%",
      backgroundColor: white,
      "& .MuiOutlinedInput-input": {
        padding: "0px !important",
      },
      "& .MuiSelect-outlined": {
        color: "primary.main",
        fontWeight: 600,
      },
      "&:hover": {
        background: "transparent",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: 0,
      },
      "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
        border: 0,
      },
      "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: 0,
      },
    },
    dropDownMenuItem: {
      "&:not(:last-child)": {
        borderBottom: "1px solid #e0e0e0",
      },
      "&.Mui-selected": {
        backgroundColor: white,
        color: theme.palette.primary.main,
        fontWeight: 500,
      },
      "&:focus": { backgroundColor: white },
    },
    textField: {
      fontSize: "16px",
      "& .MuiInputBase-input": {
        padding: "10px 8px",
      },
      "& .MuiInput-underline:before": {
        borderBottom: "1px solid #47556940 !important",
      },
      "& .MuiInput-underline:hover:before": {
        borderBottom: "1px solid #47556940 !important",
      },
      "& .MuiInput-underline:after": {
        borderBottom: `1px solid ${theme.palette.primary.main} !important`,
      },
    },
  };
};

export default settingsStyles;
